import API from "../http"
import {fetchTimeout} from "../utils/constants";

export default class AuthService {
    static async login(username, password) {
        return API.post('api/auth/login', { username, password }, {timeout: fetchTimeout})
    }

    // 2FA: перевірка email-коду (завершує вхід, бекенд ставить session-cookie)
    static async loginVerify(challengeId, code) {
        return API.post('api/auth/login/verify', { challengeId, code }, {timeout: fetchTimeout})
    }

    // 2FA: повторна відправка коду на email
    static async loginResend(challengeId) {
        return API.post('api/auth/login/resend', { challengeId }, {timeout: fetchTimeout})
    }

    static async logout() {
        return API.post('api/auth/logout',null,{timeout: fetchTimeout})
    }

    static async checkAuth() {
        return API.get('api/auth/login',{timeout:fetchTimeout})
    }
}